import type { components } from '@heidi/schema/ml-scribe';
import { useContext } from 'react';
import { useQueryLetterById } from '../../../../data/query/useQueryLetters';
import { LetterContext } from './letter-context';

type LetterResponse = components['schemas']['LetterResponse'];

export const useLetter = <TData = LetterResponse>(
  select: (data: LetterResponse | undefined) => TData
) => {
  const context = useContext(LetterContext);

  // Looks weird to branch in hook but it's fine
  if (!context) {
    throw new Error('Missing LetterProvider');
  }

  const { data } = useQueryLetterById({ letterId: context.letterId, select });
  return data;
};
